import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=5f2c0a2e"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "@/vendor/styles/pages/account.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Settings.vue?vue&type=style&index=1&id=5f2c0a2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports